import React from 'react';

import Placeholder from '@atlaskit/react-ufo/placeholder';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import type { HorizontalNav } from './main.tsx';

const LazyHorizontalSupportCenterNav = lazyForPaint<typeof HorizontalNav>(() =>
	import(/* webpackChunkName: "async-help-center-agent-studio-horizontal-nav" */ './main.tsx').then(
		({ HorizontalNav }) => HorizontalNav,
	),
);

export const AsyncSupportCenterHorizontalNav = () => {
	return (
		<Placeholder name="help-center-settings-nav" fallback={null}>
			<LazyHorizontalSupportCenterNav />
		</Placeholder>
	);
};
